import { useState } from 'react'
import { Icon } from '~/components/ui/icon.tsx'

type ShareButtonsProps = {
	url: string
	title: string
}

function ShareButtons({ url, title }: ShareButtonsProps) {
	const [copied, setCopied] = useState(false)
	const encodedUrl = encodeURIComponent(url)
	const encodedTitle = encodeURIComponent(title)

	const handleCopyLink = () => {
		navigator.clipboard.writeText(url).then(() => {
			setCopied(true)
			setTimeout(() => setCopied(false), 2000)
		})
	}

	return (
		<div className="flex items-center gap-4">
			<a
				href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`}
				target="_blank"
				rel="noreferrer"
				className="text-muted-400 transition-colors hover:text-foreground"
				aria-label="Share on X"
			>
				<svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
					<path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
				</svg>
			</a>
			<a
				href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
				target="_blank"
				rel="noreferrer"
				className="text-muted-400 transition-colors hover:text-foreground"
				aria-label="Share on LinkedIn"
			>
				<svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
					<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
				</svg>
			</a>
			<button onClick={handleCopyLink} className="text-muted-400 transition-colors hover:text-foreground" aria-label="Copy link">
				{copied ? <Icon name="check" className="h-5 w-5 text-brand" /> : <Icon name="link" className="h-5 w-5" />}
			</button>
		</div>
	)
}

export { ShareButtons }
